import React from "react";
import { Card, FormLabel, Row } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import { labels } from "../../../localization/labels";
import SubmitButton from "../SubmitButton";

const parser = value => {
  const matches = value?.match(/<em[^>[^>]*]*>[^<]*<\/em[^>[^>]*>/g);
  if (matches) {
    let result = [];
    matches.forEach(match => {
      const matchIndex = value.indexOf(match);
      result.push(value.substring(0, matchIndex));
      result.push(
        ReactHtmlParser(match.replace(/<(\/*)em[^>]*>/g, "<$1mark>"))
      );
      value = value.substr(matchIndex + match.length);
    });
    result.push(value);
    return result;
  } else {
    return value;
  }
};

export const formatDescription = description => {
  return Object.keys(description).map(key => {
    if (key && description[key]) {
      return (
        <Row>
          <FormLabel className="Label">{labels[key]}: </FormLabel>
          <FormLabel className="LabelSmall search-result-description-text">
            {parser(description[key])}
          </FormLabel>
        </Row>
      );
    } else {
      return parser(description[key]);
    }
  });
};

const SearchResult = ({ searchResult, onOpen, openInNewTab, children }) => {
  return (
    <Card className="searchResultCard">
      <Card.Body className="no-padding-top-down">
        <Card.Title className="withoutBottomMargin">
          <SubmitButton
            type="link"
            size="sm"
            className="link-text"
            text={searchResult.title}
            onClick={() => onOpen(searchResult.id, searchResult.title)}
            openInNewTab={() => openInNewTab(searchResult.id)}
          />
        </Card.Title>
        <Card.Text className="search-result-description">
          {formatDescription(searchResult?.description)}
        </Card.Text>
        {children}
      </Card.Body>
    </Card>
  );
};

export default SearchResult;
